<!-- my-component.vue -->
<template>
<!-- Button trigger modal -->

<div class="landin-1-api">
    <div class="row" style="position:absolute;z-index:6;width:100vw;margin-left:0px;">
        <div class="hidden-xs col-md-1"></div>
        <div class="col-12 col-md-7 text-landing-1">
            <h1 class="title-landing">Give your users the application they deserve.</h1>
            <h1 class="subtitle-landing">Twill build crossed-platform mobile application and deploy them into Stores for you.</h1>
            <router-link to="/price"><button class="button-app-map">Discover our Pricing</button></router-link>
        </div>
        <div class="co-12 col-md-4" style="text-align:center;margin:0;">
            <img  :src="mobile_iphoneX" style="width:270px;" >
        </div>
    </div>
    <div  style="position:absolute;bottom:0;width:100%;">
        <img :src="waves" style="width:0vw">
    </div>
    
</div>
</template>

<script scoped>

export default {
data() {
  return {
    msg: "Hello World!",
    isShowMyModal: false,
    waves: require('./assets/img/app/waves.svg'),
    mobile_app: require('./assets/img/app/mobile-app.svg'),
    mobile_iphoneX: require('./assets/img/app/iphoneX.png')
  }
}
  }
</script>
<style scoped>

.button-app-map{
    margin-top:15px;
    background-color:rgb(42, 79, 163);
    border-radius:4px;    
    color:white;
    width:200px;
    height:35px;
}
.button-app-map:hover{
    cursor: pointer;
    background-color:#537CDF;
}
/* mobile screen */
@media only screen and (max-width:70em) { 
.hidden-xs{
  display:none;
}
.landin-1-api{
  height:920px;
  position:relative;
/* blue: */
background-image: linear-gradient(-180deg, #32AEDE 0%, #3498DB 100%);
  padding-top:100px;
  width:100%;
}
}

/* big screen */
@media only screen and (min-width:70em) { 
.hidden-md{
  display:none;
}
.text-landing-1{
    padding-top:100px;
}
.landin-1-api{
  height:780px;
  position:relative;
/* 15: */
background-image: linear-gradient(-134deg, #89F7FE 0%, #66A6FF 100%);
  padding-top:100px;
  width:100%;
}
}


.title-landing{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:34px;
font-weight:normal;
}

.subtitle-landing{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:rgb(156, 155, 155);
font-size:28px;
font-weight:normal;  
}

.landin-2-website{
  height:750px;
 background-color:white;
  width:100%;
  padding-top:800px;
}


</style>


// WEBPACK FOOTER //
// src/application.vue